import {History} from '../../../graphql-typings/graphql';
import {PeriodFunction} from './period-function';
import {AccumulatingChartFunction, FunctionName} from './chart-function-types';
import {IterableUtil} from '@app/shared/util/collections/collection-utils';

export interface MaximumContext {
  maximum: number | null;
}

export class MaximumFunction extends PeriodFunction implements AccumulatingChartFunction<MaximumContext> {

  constructor() {
    super(FunctionName.MAX, 'Maximum');
  }

  run(historyArray: History[], padValues?: boolean): History[] {
    return this.applyPeriodFunction(historyArray, (ha: History[]) => this.getAggregate(this.accumulate(ha, null)), padValues);
  }

  accumulate(history: Iterable<History>, context: MaximumContext | null): MaximumContext {
    let maximum: number | null = context?.maximum ?? null;
    IterableUtil.forEach(history, historyItem => {
      maximum = Math.max(maximum ?? Number.NEGATIVE_INFINITY, historyItem.data);
    });
    const newContext: MaximumContext = {...context, maximum};
    return newContext;
  }

  getAggregate(context: MaximumContext): number {
    return context.maximum;
  }
}
